<div class="doc-modal">
  <div class="doc-modal__header">
    <div class="doc-modal__header-left">
      <div class="doc-modal__icon"><i class="fas" [ngClass]="modalIcon"></i></div>
      <div>
        <div class="doc-modal__title">{{ modalTitle }}</div>
        <div class="doc-modal__subtitle" *ngIf="timeLabel">{{ timeLabel }}</div>
      </div>
    </div>
    <button type="button" class="doc-modal__close" aria-label="Close" (click)="activeModal.dismiss()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div
    class="doc-modal__patient-bar"
    *ngIf="patientName || patientMrn || providerName || (docType === 'medical-necessity' && actionItem?.order?.primary_payer_name)"
  >
    <span *ngIf="patientName"><i class="fas fa-user"></i> {{ patientName }}</span>
    <span *ngIf="patientMrn"><i class="fas fa-id-badge"></i> MRN {{ patientMrn }}</span>
    <span *ngIf="providerName"><i class="fas fa-user-md"></i> {{ providerName }}</span>
    <span *ngIf="docType === 'medical-necessity' && actionItem?.order?.primary_payer_name">
      <i class="fas fa-id-card"></i> {{ actionItem.order.primary_payer_name }}
    </span>
  </div>

  <div class="doc-modal__body">
    <!-- Doctor Notes -->
    <ng-container *ngIf="docType === 'doctor-notes'">
      <div class="doc-section" *ngIf="doctorNotes['History Of Present Illness']">
        <div class="doc-section__title"><i class="fas fa-comment-medical"></i> History of Present Illness</div>
        <p>{{ doctorNotes['History Of Present Illness'] }}</p>
      </div>
      <div class="doc-section" *ngIf="doctorNotes['Physical Examination']">
        <div class="doc-section__title"><i class="fas fa-stethoscope"></i> Physical Examination</div>
        <p>{{ doctorNotes['Physical Examination'] }}</p>
      </div>
      <div class="doc-section" *ngIf="doctorNotes['Diagnostics']">
        <div class="doc-section__title"><i class="fas fa-vial"></i> Diagnostics</div>
        <p>{{ doctorNotes['Diagnostics'] }}</p>
      </div>
      <div class="doc-section" *ngIf="assessmentPoints.length">
        <div class="doc-section__title"><i class="fas fa-clipboard-list"></i> Assessment / Plan</div>
        <ul class="doc-bullets">
          <li *ngFor="let point of assessmentPoints">{{ point }}</li>
        </ul>
      </div>

      <ng-container *ngIf="hasRecommendations">
        <div class="doc-divider"><i class="fas fa-lightbulb"></i> Recommendations</div>

        <div class="doc-rec-table" *ngIf="recommendations!.tests.length">
          <div class="doc-rec-table__title">Tests</div>
          <div class="doc-rec-row" *ngFor="let t of recommendations!.tests">
            <span class="doc-rec-row__related" *ngIf="t.related_to">{{ t.related_to }}</span>
            <span class="doc-rec-row__primary">{{ t.primary }}</span>
            <span class="doc-rec-row__secondary" *ngIf="t.secondary">{{ t.secondary }}</span>
          </div>
        </div>

        <div class="doc-rec-table" *ngIf="recommendations!.medications.length">
          <div class="doc-rec-table__title">Medications</div>
          <div class="doc-rec-row" *ngFor="let m of recommendations!.medications">
            <span class="doc-rec-row__related" *ngIf="m.related_to">{{ m.related_to }}</span>
            <span class="doc-rec-row__primary">{{ m.primary }}</span>
            <span class="doc-rec-row__secondary" *ngIf="m.secondary">{{ m.secondary }}</span>
          </div>
        </div>

        <div class="doc-rec-table" *ngIf="recommendations!.treatments.length">
          <div class="doc-rec-table__title">Treatments</div>
          <div class="doc-rec-row" *ngFor="let t of recommendations!.treatments">
            <span class="doc-rec-row__related" *ngIf="t.related_to">{{ t.related_to }}</span>
            <span class="doc-rec-row__primary">{{ t.primary }}</span>
            <span class="doc-rec-row__secondary" *ngIf="t.secondary">{{ t.secondary }}</span>
          </div>
        </div>

        <div class="doc-rec-table" *ngIf="recommendations!.risk_factors.length">
          <div class="doc-rec-table__title">Risk Factors</div>
          <div class="doc-rec-row" *ngFor="let r of recommendations!.risk_factors">
            <span class="doc-rec-row__related" *ngIf="r.related_to">{{ r.related_to }}</span>
            <span class="doc-rec-row__primary">{{ r.primary }}</span>
          </div>
        </div>

        <div class="doc-section" *ngIf="recommendations!.considerations">
          <div class="doc-section__title"><i class="fas fa-circle-info"></i> Considerations</div>
          <p>{{ recommendations!.considerations }}</p>
        </div>
      </ng-container>

      <div class="doc-section" *ngIf="actionItems.length">
        <div class="doc-section__title"><i class="fas fa-tasks"></i> Action Items ({{ actionItems.length }})</div>
        <div class="doc-action-item" *ngFor="let item of actionItems; let i = index">
          <strong>{{ i + 1 }}. {{ item.name || item.actions }}</strong>
          <p *ngIf="item.description">{{ item.description }}</p>
        </div>
      </div>

      <div class="doc-empty" *ngIf="!hasDoctorNotesContent">
        <i class="fas fa-file-circle-question"></i> No doctor notes content available.
      </div>
    </ng-container>

    <!-- Transcription -->
    <ng-container *ngIf="docType === 'transcription'">
      <div class="transcript-turn" *ngFor="let turn of speakerTurns" [ngClass]="speakerClass(turn.idx)">
        <div class="transcript-turn__badge" *ngIf="turn.label">{{ turn.label }}</div>
        <div class="transcript-turn__bubble">{{ turn.text }}</div>
      </div>
      <div class="doc-empty" *ngIf="!speakerTurns.length">
        <i class="fas fa-microphone-slash"></i> No transcription content available.
      </div>
    </ng-container>

    <!-- Medical Necessity -->
    <ng-container *ngIf="docType === 'medical-necessity'">
      <div class="doc-section" *ngIf="mnIndicator">
        <div class="doc-section__title"><i class="fas fa-shield-alt"></i> Coverage</div>
        <span
          class="doc-mn-badge"
          [ngClass]="{
            'doc-mn-badge--approved': mnIndicator === 'approved',
            'doc-mn-badge--missing': mnIndicator === 'missing',
            'doc-mn-badge--not-approved': mnIndicator === 'not-approved'
          }"
        >
          <span class="doc-mn-badge__dot"></span>
          {{ mnIndicatorLabel }}
        </span>
      </div>

      <div class="doc-section" *ngIf="actionItem?.order?.order_summary || actionItem?.order?.order_number">
        <div class="doc-section__title"><i class="fas fa-file-medical"></i> Order</div>
        <div class="doc-kv" *ngIf="actionItem?.order?.order_number">
          <span class="doc-kv__label">Order Number</span>
          <span class="doc-kv__value">{{ actionItem.order.order_number }}</span>
        </div>
        <p *ngIf="actionItem?.order?.order_summary">{{ actionItem.order.order_summary }}</p>
      </div>

      <div class="doc-section" *ngIf="actionItem?.action_item">
        <div class="doc-section__title"><i class="fas fa-tasks"></i> Action Item</div>
        <p>{{ actionItem.action_item }}</p>
      </div>

      <div class="doc-rec-table" *ngIf="orderCptCodes.length">
        <div class="doc-rec-table__title">CPT Codes</div>
        <div class="doc-rec-row" *ngFor="let code of orderCptCodes">
          <span class="doc-rec-row__primary">{{ code.code }}</span>
          <span class="doc-rec-row__secondary" *ngIf="code.reason">{{ code.reason }}</span>
        </div>
      </div>

      <ng-container *ngIf="coverageDetails.length">
        <div class="doc-divider"><i class="fas fa-align-left"></i> Coverage Notes</div>
        <div class="doc-coverage-note" *ngFor="let d of coverageDetails">
          <div class="doc-coverage-note__label" *ngIf="coverageDetails.length > 1">{{ d.label }}</div>
          <div
            class="doc-coverage-block"
            *ngFor="let block of d.blocks"
            [ngClass]="{
              'doc-coverage-block--numbered': block.type === 'numbered',
              'doc-coverage-block--bullet': block.type === 'bullet'
            }"
          >
            <span class="doc-coverage-block__number" *ngIf="block.type === 'numbered'">{{ block.number }}</span>
            <span class="doc-coverage-block__bullet" *ngIf="block.type === 'bullet'">&bull;</span>
            <p>
              <span class="doc-coverage-block__label" *ngIf="block.label">{{ block.label }}</span>
              {{ block.text }}
            </p>
          </div>
        </div>
      </ng-container>

      <div class="doc-empty" *ngIf="!hasMedicalNecessityContent">
        <i class="fas fa-shield-alt"></i> No medical necessity details available yet.
      </div>
    </ng-container>

    <!-- Billing Summary -->
    <ng-container *ngIf="docType === 'billing-summary'">
      <div class="doc-rec-table" *ngIf="billingCodeRows.length">
        <div class="doc-rec-table__title">CPT Codes</div>
        <div class="doc-rec-row" *ngFor="let row of billingCodeRows">
          <span class="doc-rec-row__related" *ngIf="row.isAddOn">Add-on</span>
          <span class="doc-rec-row__primary">{{ row.code }}<ng-container *ngIf="row.description"> — {{ row.description }}</ng-container></span>
          <span class="doc-rec-row__secondary" *ngIf="row.icd10">ICD-10: {{ row.icd10 }}</span>
          <span class="doc-rec-row__secondary" *ngIf="row.reason">{{ row.reason }}</span>
        </div>
      </div>

      <div class="doc-section" *ngIf="billingReport">
        <div class="doc-section__title"><i class="fas fa-align-left"></i> Billing Report</div>
        <p>{{ billingReport }}</p>
      </div>

      <div class="doc-empty" *ngIf="!hasBillingSummaryContent">
        <i class="fas fa-file-invoice-dollar"></i> No billing summary available yet.
      </div>
    </ng-container>
  </div>

  <div class="doc-modal__footer">
    <button type="button" class="doc-modal__btn doc-modal__btn--ghost" (click)="activeModal.dismiss()">Close</button>
    <button type="button" class="doc-modal__btn doc-modal__btn--primary" (click)="onDownload()">
      <i class="fas fa-file-pdf"></i> Download PDF
    </button>
  </div>
</div>
